export default __webpack_public_path__ + "a6c24f9e0443ad38a3ca7f9d5b19b185.svg";